var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.alert)?_c('div',{staticClass:"main-alert",class:`main-alert_${_setup.alert.type}`},[_c('SvgIcon',{staticClass:"main-alert__icon",attrs:{"name":"error-icon","width":"14px","height":"14px"}}),_c('div',{staticClass:"main-alert__text",domProps:{"innerHTML":_vm._s(_setup.alert.text)}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }